import { NEXT_PUBLIC_OAUTH_API } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";

export const getOauthAuthCodeAPI = async (
  response_type: string,
  redirect_uri: string,
  state: string,
  code_challenge: string
): Promise<any> => {
  try {
    return await fetchUtil({
      url: `${NEXT_PUBLIC_OAUTH_API}/api/authorize?response_type=${response_type}&redirect_uri=${redirect_uri}&state=${state}&code_challenge=${code_challenge}`,
      method: "GET",
      body: {},
      ctype: "",
      useToken: false,
    });
  } catch (err) {
    console.error("Unable to get oAuth code", err);
  }
};

export const getPreAuthKeyAPI = async (auth_code: string, code_verifier: string): Promise<any> => {
  let PreAuthToken = {};
  const options = {
    method: "POST",
    headers: {
      "x-app-device-id": "Desktop",
    },
  };

  try {
    PreAuthToken = await fetch(
      `${NEXT_PUBLIC_OAUTH_API}/api/token?grant_type=authorization_code&auth_code=${auth_code}&code_verifier=${code_verifier}`,
      options
    )
      .then((response) => response.json())
      .then((response) => response);
  } catch (err) {
    console.error("Unable to get PreAuthToken", err);
  }

  return PreAuthToken;
};
